<template>
  <client-only>
    <div :class="['submit-temp', bindClass]">
      <div class="main-content" :style="payBgColor">
        <template v-if="!isDesktop">
          <div v-show="payStatus !== 'pending' && isRenderTemp">
            <NewCoupon
              :couponAfterMoney="couponAfterMoney"
              :discountAmount="payChannelprice"
            />
          </div>
          <MainTemp />
        </template>
        <template v-else>
          <DesktopBill>
            <MainTemp />
          </DesktopBill>
        </template>
      </div>
    </div>
  </client-only>
</template>
<script>
  import isEmpty from 'lodash/isEmpty'
  import NewCoupon from '@page_detail/components/Coupon/new'
  import MainTemp from './mainTemp'
  import DesktopBill from './desktop'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapState, mapGetters } from 'vuex'
  import { sub } from '@/utils/accurateNumber'
  import calculatePrice from '@/mixins/detail/calculatePrice'
  export default {
    name: 'New-Submit-Btn',
    mixins: [styleConfiguration, calculatePrice],
    data() {
      return {
        discountAmount: 0,
      }
    },
    components: {
      NewCoupon,
      MainTemp,
      DesktopBill,
    },
    computed: {
      ...mapState(['isDesktop', 'pubgmDiscount']),
      ...mapGetters(['isRuPubgm']),
      ...mapState('detail', [
        'selectChannelItem',
        'selectSkuItem',
        'payStatus',
        'isShowDiscount',
      ]),
      // 列表型的SKU、进行搜索交互的时候需要隐藏价格信息、只有点击才能生效
      isRenderTemp() {
        if (this.skuModuleType === 2) {
          return !isEmpty(this.selectSkuItem)
        }
        return true
      },

      couponAfterMoney() {
        return this.selectSkuItem.originalPrice
      },
      bindClass() {
        if (this.isDesktop) return 'submit-desktop'
        return this.isShowDiscount ? 'new-discount' : ''
      },

      // 正确计算的逻辑
      actualPrice() {
        const { channelPrice } = this.selectChannelItem
        return sub(channelPrice, this.discountMoney)
      },
    },
    watch: {},
    methods: {},
  }
</script>
<style lang="scss" scoped src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
  @media (max-width: 900px) {
    @import './900.scss';
  }
</style>
